import { initializeMatomo } from 'src/Services/Matomo';
import { initializeMixpanel } from 'src/Services/Mixpanel';
import { initializeSentry, rememberAnalyticsConsent } from 'src/Services/Sentry';

import { setUserConsentProvider } from '../UserConsentProvider/context';

interface HubSpotConsentData {
  allowed?: boolean;
  categories?: {
    analytics?: { accepted?: boolean };
  };
}

export const setupConsentAwareServices = () => {
  console.log('[Consent] Setting up HubSpot privacy consent listener for services.');

  // Mixpanel is always initialized regardless of consent
  initializeMixpanel();
  setUserConsentProvider({ consentForAnalytics: true });

  // Sentry starts BEFORE any consent decision so technical crashes are captured
  // even when the user refuses or ignores the cookie banner. PII is stripped by
  // Sentry.init options (sendDefaultPii: false + beforeSend); replays stay off
  // until analytics consent has been persisted (see rememberAnalyticsConsent).
  initializeSentry();

  if (import.meta.env.DEV) {
    console.log('[Consent] Dev mode: auto-granting analytics consent.');
    rememberAnalyticsConsent(true);
    initializeMatomo();
    return;
  }

  window._hsp = window._hsp || [];
  window._hsp.push([
    'addPrivacyConsentListener',
    (consent: HubSpotConsentData) => {
      console.log(
        '[Consent] HubSpot addPrivacyConsentListener CALLBACK FIRED. Consent object:',
        consent
      );

      let hasGivenConsentForAnalytics = false;

      if (consent.categories?.analytics?.accepted === true) {
        hasGivenConsentForAnalytics = true;
        console.log('[Consent] Analytics consent GRANTED via categories by HubSpot.');
      } else if (consent.allowed === true) {
        console.warn(
          '[Consent] consent.allowed is true, but consent.categories.analytics is not explicitly true. Assuming consent for Matomo based on "allowed".'
        );
        hasGivenConsentForAnalytics = true;
      }

      if (hasGivenConsentForAnalytics) {
        // Persist so Sentry replays activate on the next page load — replay sample
        // rates cannot be changed at runtime.
        rememberAnalyticsConsent(true);
        initializeMatomo();
      } else {
        console.log(
          '[Consent] Analytics consent NOT granted by HubSpot. Matomo will not be initialized (Sentry stays on without PII). Current consent state:',
          consent
        );
        rememberAnalyticsConsent(false);
      }
    },
  ]);
};
